import type { ReactElement } from 'react'

import { Navigate } from 'react-router'

import { type ReleaseGate, useReleaseGate } from '~/hooks/releaseGate'
import { routePaths } from '~/routes/routePaths'

/**
 * release flag で route を開閉する。 page 自身は flag を知らない。
 * pending (取得前) は何も描かず、 off (OFF・評価失敗) は home へ置き換え、 on だけ children を描く。
 * `gate` は route ごとに固定の値を渡す。
 */
export const ReleaseRouteGate = ({
  gate,
  children,
}: {
  gate: ReleaseGate
  children: ReactElement
}): ReactElement | null => {
  const state = useReleaseGate(gate)
  if (state === 'pending') return null
  if (state === 'off') return <Navigate replace to={routePaths.home.path} />
  return children
}
